export const studioInfo = {
    // Lời chào
    greeting: "Xin chào! Tôi là \"Quản Gia Online\" của Thế Trung Tattoo Studio. Tôi có thể giúp gì cho bạn?",
    name: "Thế Trung Tattoo Studio",
    phone: "0378 927 665",
    address: "52 Nguyễn Nhạc, Phường Quy Nhơn Đông, Tỉnh Gia Lai",
    time: "8:00 - 17:30 (Thứ 2 - Thứ 7 hằng tuần)",
    payment: [
        "Tiền mặt",
        "Chuyển khoản",
        "ZaloPay",
        "Momo",
    ],
    // Dịch vụ chính
    specialties: [
        "Xăm hình nghệ thuật",
        "Tattoo custom theo yêu cầu",
        "Cover-up tattoo cũ",
        "Tư vấn thiết kế",
        "Chăm sóc sau xăm"
    ],
    // Giá cả (tham khảo)
    pricing: {
        small: "2tr - 3tr",      
        medium: "5tr - 8tr",     
        large: "8tr - 12tr",       
        extraLarge: "15tr - 17tr",   
        coverUp: "+50% giá gốc"  
    },
    // Quy trình
    process: [
        { step: "Bước 1", title: "Tư vấn & ý tưởng", desc: "Lắng nghe mong muốn của khách hàng và định hình phong cách hình xăm phù hợp." },
        { step: "Bước 2", title: "Thiết kế & chỉnh sửa", desc: "Phác thảo và điều chỉnh mẫu xăm theo yêu cầu, đảm bảo đúng ý tưởng của khách hàng." },
        { step: "Bước 3", title: "Xác nhận & thanh toán cọc 30%", desc: "Xác nhận thiết kế cuối cùng, chuẩn bị dụng cụ và đặt lịch thực hiện." },
        { step: "Bước 4", title: "Thực hiện hình xăm", desc: "Tiến hành xăm trong môi trường vô trùng tuyệt đối với thiết bị đạt chuẩn." },
        { step: "Bước 5", title: "Hoàn thiện & chăm sóc", desc: "Hoàn tất hình xăm và hướng dẫn khách hàng cách chăm sóc đúng cách." },
        { step: "Bước 6", title: "Theo dõi & bảo hành", desc: "Theo dõi quá trình hồi phục và bảo hành hình xăm khi cần thiết." }
      ],
      

};
